import React from 'react';

import styles from './Slider.module.scss';
import img from '../../assets/sliderBg1.jpg';


class Slider extends React.Component {
  render() {
    const bgImageStyle = {
      backgroundImage: `url("${img}")`,
    };
    return (
      <div className={styles.SliderContainer}>
        <div className={styles.Image} style={bgImageStyle}/>
      </div>
    );
  }
}

export default Slider;
